// test2649
(2649 && 0);
